import {
  MATERIAL_ALL,
  MATERIAL_GET,
  MATERIAL_DEL,
  MATERIAL_PUT,
  MATERIAL_POST,
  MATERIAL_LOADING,
  MATERIAL_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const materialCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: MATERIAL_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/material`,
      {
        ...payload,
      },
    );
    dispatch({ type: MATERIAL_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_ERROR });
    throw new Error(error);
  }
};

export const materialAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = 5, page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/material?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: MATERIAL_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_ERROR });
    throw new Error(error);
  }
};

export const materialGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/material/${id}`,
    );
    if (status === 200) {
      dispatch({ type: MATERIAL_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_ERROR });
    throw new Error(error);
  }
};

export const materialPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: MATERIAL_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/material/${id}`,
      payload,
    );
    dispatch({ type: MATERIAL_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_ERROR });
    throw new Error(error);
  }
};
export const materialDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: MATERIAL_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/material/${id}`,
    );
    dispatch({ type: MATERIAL_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_ERROR });
    throw new Error(error);
  }
};
